
import React, { useRef, useState, useEffect } from "react";
import { BASE_URL } from "../../constants";
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Form, Row, Col, Container, Card, Button, InputGroup } from 'react-bootstrap';
import '../../CommonCSS/SocietyCSS.css';

const Timetable = () => {

  //  const [sctyData, setSctData] = useState([]);

  const [isListening, setIsListening] = useState(false);
  const [pdfURL, setPdfURL] = useState(null);
  const [ddlStandards, setDdlStandards] = useState([]);
  const [ddlDivisions, setDdlDivisions] = useState([]);

  const fileInputRef = useRef(null);
  const recognitionRef = useRef(null);

  const [formData, setFormData] = useState({
    std_id: '',
    div_id: '',
    validtill: '',
    time_table_text: '',
    selected_file: '',
    noticeText: "",
    speechText: "",
    // off_time_wkdays_even_to: '',
    // off_time_holi_fr: '',
    // off_time_holi_to: '',
  });

  // const [showModal, setShowModal] = useState(false);
  // const [showIntModal, setShowIntModal] = useState(false);
  // const [showDiscountModal, setShowDiscountModal] = useState(false);
  // const [showParkingModal, setShowParkingModal] = useState(false);

  useEffect(() => {
    const fetchLists = async () => {
      try {
        const stdresult = await axios.get(`${BASE_URL}/api/ddl_all_standards`);
        setDdlStandards(stdresult.data);
        const res = await axios.get(`${BASE_URL}/api/ddl_all_division`);
        setDdlDivisions(res.data || []);
        //        console.log('premtypeRes.data =====> ', premtypeRes.data);
      } catch (err) {
        console.error("Dropdown fetch error:", err);
      }
    };
    fetchLists();
  }, []);

  useEffect(() => {

    if ("webkitSpeechRecognition" in window) {
      const recognition = new window.webkitSpeechRecognition();
      recognition.continuous = true;
      recognition.interimResults = false;

      recognition.onresult = (event) => {
        const transcript = event.results[event.results.length - 1][0].transcript;
        setFormData((prev) => ({
          ...prev,
          speechText: prev.speechText + " " + transcript
        }));
      };

      recognition.onerror = () => setIsListening(false);

      recognition.onend = () => {
        // When speech recognition fully stops
        setIsListening(false);
      };

      recognitionRef.current = recognition;
    }

  }, []);

  const startListening = () => {
    if (!recognitionRef.current) {
      alert("Speech Recognition not supported");
      return;
    }
    setIsListening(true);
    recognitionRef.current.start();
  };

  const stopListening = () => {
    if (recognitionRef.current) {
      recognitionRef.current.stop();
    }
    setIsListening(false);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleFileUpload = (e) => {

    const file = e.target.files[0];
    if (!file) return;

    const previewURL = URL.createObjectURL(file);
    setPdfURL(previewURL);

    setFormData(prev => ({
      ...prev,
      pdfFile: file
    }));
  };

  const handleMoveSpeachToTextBox = async () => {

    setFormData(prev => ({
      ...prev,
      noticeText:
        prev.noticeText
          ? prev.noticeText + "\n" + prev.speechText   // append with new line
          : prev.speechText,                            // or replace if empty
      speechText: ""
    }));

  };

  const handleEmptySpeechText = async () => {

    const confirmClear = window.confirm("Sure you want to move clear Speech Text ?");
    if (!confirmClear) return;

    setFormData(prev => ({
      ...prev,
      speechText: "",
    }));

  };

  const handleSave = async () => {

    if (!formData.std_id) {
      alert("Please select Standard");
      return;
    }

    if (!formData.div_id) {
      alert("Please select Division");
      return;
    }

    if (!formData.pdfFile) {
      alert("Please upload TimeTable PDF");
      return;
    }

    const confirmSave = window.confirm("Sure you want to upload TimeTable?");
    if (!confirmSave) return;

    try {
      const formDataToSend = new FormData();

      formDataToSend.append("noticeFile", formData.pdfFile); // IMPORTANT
      formDataToSend.append("std_id", formData.std_id);
      formDataToSend.append("div_id", formData.div_id);
      formDataToSend.append("validtill", formData.validtill);
      formDataToSend.append("noticeText", formData.noticeText);

      const response = await axios.post(
        `${BASE_URL}/api/upload_TimeTable`,
        formDataToSend,
        {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        }
      );

      alert("TimeTable uploaded successfully!");

      console.log("Uploaded File:", response.data.filename);

    } catch (error) {
      console.error("Upload Error:", error);
      alert("TimeTable upload failed!");
    }
  };

  return (
    <Container fluid className="p-3">
      <Card style={{ marginTop: '10px', padding: '15px' }}>
        <Row className="mb-3">

          <Col md={4}>
            <InputGroup>
              <InputGroup.Text style={{ width: "90px" }}>
                Standard
              </InputGroup.Text>
              <select
                className="form-select"
                name="std_id"
                value={formData.std_id}
                onChange={handleChange}
              >
                <option value="">-- Select Standard--</option>
                {ddlStandards.map(std => (
                  <option key={std.std_id} value={std.std_id}>{std.std_name}</option>
                ))}
              </select>
            </InputGroup>
          </Col>

          <Col md={4}>
            <InputGroup>
              <InputGroup.Text style={{ width: "90px" }}>
                Division
              </InputGroup.Text>
              <select
                className="form-select"
                name="div_id"
                value={formData.div_id}
                onChange={handleChange}
              >
                <option value="">-- Select Division--</option>
                {ddlDivisions.map(div => (
                  <option key={div.div_id} value={div.div_id}>{div.div_name}</option>
                ))}

              </select>
            </InputGroup>
          </Col>

          <Col md={3}>
            <InputGroup>
              <InputGroup.Text style={{ width: "120px" }}>
                Valid Till Date
              </InputGroup.Text>
              <Form.Control
                type="date"
                name="validTill"
                value={formData.validTill}
                onChange={handleChange}
              />
            </InputGroup>
          </Col>
        </Row>

        {/* <Row className="mb-3">

          <Col md={6}>
            <InputGroup>
              <InputGroup.Text style={{ width: "150px" }}>
                Time Table Text<span style={{ color: "red" }}>*</span>
              </InputGroup.Text>
              <textarea
                name="time_table_text"
                className="form-control"
                rows="3"
                value={formData.time_table_text}
                onChange={handleChange}
                disabled={!isEditable}
              />
            </InputGroup>
          </Col>
          
        </Row> */}
        <Row className="mb-3">

          <Col md={6}>
            <Form.Floating className="mb-3">
              <Form.Control
                as="textarea"
                style={{ height: "300px" }}
                name="noticeText"
                value={formData.noticeText}
                onChange={handleChange}
                placeholder="Type your notice here..."
              />
              <label className="fw-bold">Notice Text</label>
              <div style={{ textAlign: "right", fontSize: "12px", color: "#555" }}>
                {formData.noticeText.length} characters
              </div>
            </Form.Floating>
          </Col>
          {/* Speech to Text Row */}
          <Col md={6}>
            <Form.Floating className="mb-3">
              <Form.Control
                as="textarea"
                style={{ height: "250px" }}
                name="speechText"
                value={formData.speechText}
                onChange={handleChange}
                readOnly
                placeholder="Speak your notice here..."
              />
              <label className="fw-bold">Speech To Text</label>
            </Form.Floating>
            <div className="mt-2">
              {!isListening ? (
                <Button variant="primary" onClick={startListening} className="me-2">
                  🎤 Start Listening
                </Button>
              ) : (
                <Button variant="danger" onClick={stopListening} className="me-2">
                  ⏹ Stop
                </Button>
              )}
              <Button variant="primary" onClick={handleMoveSpeachToTextBox} disabled={formData.speechText.length === 0} className="me-2">
                Move Text To Notice Text
              </Button>
              <Button variant="secondary" onClick={handleEmptySpeechText} disabled={formData.speechText.length === 0} className="me-2">
                Empty Speech Text
              </Button>
            </div>
          </Col>
          {/* PDF Upload */}
          <Col md={6}>
            {/* <Form.Label>Select PDF File:</Form.Label> */}
            <Form.Control type="file" accept="application/pdf" onChange={handleFileUpload} ref={fileInputRef} id="formFileSm" />

            {pdfURL && (
              <div className="mt-3">
                <h6>PDF Preview:</h6>
                <iframe
                  src={pdfURL}
                  title="PDF Preview"
                  width="100%"
                  height="300px"
                  style={{ border: "1px solid #ccc" }}
                ></iframe>
              </div>
            )}
          </Col>
        </Row>

        <Row className="mb-3 justify-content-end">
          <Col md="auto">
            <button className="btn btn-success" onClick={handleSave}>
              Save
            </button>
          </Col>
        </Row>
      </Card>

    </Container>
  );
};
export default Timetable;
